<template>

  <div class="padded">
    <h2><i class="fa fa-wifi" />&nbsp;<org-badge />&nbsp;Backhaul Dashboard<small v-if="!isTowerCo() && org().shortName" class="text-info pull-right hidden-sm-and-down">{{org().name}}</small></h2>
    <p />
    <el-tabs v-model="selected" type="border-card">
      <el-tab-pane label="Providers" name="provider">
        <backhaul-provider-summary />
      </el-tab-pane>

      <el-tab-pane label="Customers" name="subscriber">
        <backhaul-subscriber-summary />
      </el-tab-pane>

      <el-tab-pane label="Sites by Provider" name="sites">
        <backhaul-table no-add />
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>

import NumberMixins from '@/mixins/NumberMixins'

import BackhaulProviderSummary from '@/components/dashboard/backhaul/BackhaulProviderSummary'
import BackhaulSubscriberSummary from '@/components/dashboard/backhaul/BackhaulSubscriberSummary'
import BackhaulTable from '@/components/backhaul/BackhaulTable'

export default {
  mixins: [NumberMixins],

  components: {
    BackhaulProviderSummary,
    BackhaulSubscriberSummary,
    BackhaulTable
  },

  data () {
    return {
      selected: 'provider'
    }
  }

}
</script>
